<template>
  <v-card width="100%" class="ma-0 pa-0" outlined>
    <v-toolbar flat>
      <v-toolbar-title>Branches</v-toolbar-title>
      <v-divider class="mx-2" inset vertical/>

      <v-card-actions class="ma-0 pa-0">
        <v-spacer></v-spacer>
        <v-btn color="accent" @click="row_create">
          Add Branch
        </v-btn>
      </v-card-actions>
      <v-spacer/>
    </v-toolbar>

    <v-data-table
        style="width: 100%;"
        fixed-header
        :items="branches"
        :headers="headers"
        hide-default-footer
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        disable-pagination>
      <template v-slot:item.groups = "{ item }">
        <div>
          <v-chip
              v-for="group in item.groups"
              :key="group.name"
              class="ma-1"
              color="blue lighten-4"
              text-color="blue--text"
              small>
            {{ group.name }}
          </v-chip>
        </div>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <c-branch-dialog ref="branchDialog"></c-branch-dialog>
  </v-card>
</template>
<script>
import {ViewRules} from "@/common/ViewRules";
import BranchStoreUtils from "@/modules/mconfigs/database/BranchStoreUtils";
import CBranchDialog from "@/modules/mconfigs/views/branch/c-branch-dialog.vue";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";

export default {
  name: "c-branch-table",
  components: {CBranchDialog},
  data: () => ({
    headers: [
      {text: 'Branch', sortable: true, value: 'name', class: "white blue--text", color: "red"},
      {text: 'Order', sortable: true, value: 'order', class: "white blue--text", color: "red"},
      {text: 'Groups', sortable: true, value: 'groups', class: "white blue--text", color: "red"},
      {text: 'Actions', sortable: false, value: 'actions', align: 'center', class: "white blue--text", color: "red"},
    ],
    loading: null,
    visible: false,
    sortBy: 'order',
    sortDesc: false,
  }),
  methods: {
    row_copy(item) {
      this.$refs.branchDialog.show(ViewRules.COPY, item.copy())
          .then((result) => {
            if (!this.validate_branch(result)) {
              return;
            }
            BranchStoreUtils.pushValue(result)
                .then(() => {
                  this.$notify({title: 'Branch successfully created!', text: "", type: "success"});
                })
                .catch((error) => {
                  this.$notify({title: 'Branch creation failed!', text: error, type: "error"});
                })
          })
          .catch(() => {});
    },
    row_update(item) {
      this.$refs.branchDialog.show(ViewRules.UPDATE, item)
          .then((result) => {
            if (!this.validate_branch(result)) {
              return;
            }
            BranchStoreUtils.pushValue(result)
                .then(() => {
                  this.$notify({title: 'Branch successfully created!', text: "", type: "success"});
                })
                .catch((error) => {
                  this.$notify({title: 'Branch creation failed!', text: error, type: "error"});
                })
          })
          .catch(() => {});
    },

    row_remove(item) {
      const configsCount = ConfigStoreUtils.getReleaseConfigs()
          .filter(c => item.groups.find(g => c.group?.toLowerCase() === g.name?.toLowerCase())).length;
      const message = configsCount > 0
          ? `Are you sure you want to delete this branch? ${configsCount} config(s) will be moved to "No Branch".`
          : `Are you sure you want to delete this branch?`;
      this.$confirm(message).then(() => {
        BranchStoreUtils.removeValue(item.uid).then(() => {
          this.$notify({title: 'Branch successfully deleted!', text: "", type: "success"});
        }).catch((error) => {
          this.$notify({title: 'Branch deletion failed!', text: error, type: "error"});
        });
      });
    },
    row_create() {
      this.$refs.branchDialog.show(ViewRules.CREATE, null)
          .then((result) => {
            if (!this.validate_branch(result)) {
              return;
            }
            BranchStoreUtils.pushValue(result)
                .then(() => {
                  this.$notify({title: 'Branch successfully created!', text: "", type: "success"});
                })
                .catch((error) => {
                  this.$notify({title: 'Branch creation failed!', text: error, type: "error"});
                })
          })
          .catch(() => {});
    },
    validate_branch(item) {
      const savedValues = BranchStoreUtils.getValues();
      const duplicatedBranch = savedValues.find(b => b.name === item.name && b.uid !== item.uid);
      const duplicatedGroups = item.groups.length > 0 && item.groups.some(g =>
          savedValues.some(b =>
              b.uid !== item.uid &&
              b.groups.some(bg => bg.name?.toLowerCase() === g.name?.toLowerCase())
          )
      );
      if (duplicatedBranch) {
        this.$alert("Branch name already exists!");
        return false;
      }

      if (duplicatedGroups) {
        this.$alert("One or more groups are already assigned to another branch!");
        return false;
      }
      return true;
    }
  },
  computed: {
    branches() {
      return BranchStoreUtils.getValues();
    }
  }
}
</script>